
const ComingSoon = () => {
  return (
    <div className="d-flex justify-content-center py-5">
        <p style={{fontSize: "60px",color: "#270B79",fontWeight: "600"}}>
        Coming 
       <span style={{color:'#FF8D5C'}}>  Soon...</span>
        </p>
        </div>
  )
}

export default ComingSoon